import GenericMessage from './GenericMessage';
import styles from './errorMessage.module.less';

const ErrorMessage = ({ children, className = '' }) => (
    <GenericMessage
        icon="error"
        iconStyle={styles.icon}
        containerStyle={styles.messageContainer}
        textStyle={styles.text}
        className={className}
    >
        {children}
    </GenericMessage>
);

export default ErrorMessage;
